import { MarketingChrome } from "./MarketingChrome";
import { PilotInquiryForm } from "./PilotInquiryForm";
import { useTranslation } from "react-i18next";
import "./MarketingHome.css";

export default function PilotPage() {
  const { t } = useTranslation();
  return (
    <MarketingChrome>
      <main id="mh-main" className="mh-wrap mh-flow-page">
        <p className="mh-eyebrow">{t("mhPilotEyebrow")}</p>
        <h1>{t("mhPilotTitle")}</h1>
        <p className="mh-lead">{t("mhPilotWhat")}</p>
        <div style={{ maxWidth: 560, marginTop: 24 }}>
          <PilotInquiryForm />
        </div>
      </main>
    </MarketingChrome>
  );
}
